export default __webpack_public_path__ + "static/ivanova1-9c238b4745017f28acbf6b4ac326ec8a.jpg";